// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"81e228b6d2d5608a4713","121":"7f04caead6f33bba178a","122":"fc37853e02bcbf806c50","169":"9d676057cfab743a7192"}[chunkId] + ".chunk.js";
};